import { render, staticRenderFns } from "./AddNewRegionsPopUp.vue?vue&type=template&id=c9c67e7a&scoped=true&"
import script from "./AddNewRegionsPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewRegionsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewRegionsPopUp.vue?vue&type=style&index=0&id=c9c67e7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c67e7a",
  null
  
)

export default component.exports